import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as appHelper from '../../helpers/appHelper';
import {EXIT_CONFIG} from '../../models/dialogModels';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as navigationConstants from '../../constants/navigationConstants';
import * as environmentHelper from '../../helpers/environmentHelper';


class ExitButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            exit_label: appHelper.getLocaleString("exit_label"),
            save_and_exit_label: appHelper.getLocaleString("save_and_exit_label"),
            close_label: appHelper.getLocaleString("close_label"),
            env: environmentHelper.getEnvironment(),
        };
        this.exit = this.exit.bind(this);
        this.setBtnClass = this.setBtnClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getLabel = this.getLabel.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("exit_label"),
            });
        }
    }

    exit() {
        let config = Object.assign({}, EXIT_CONFIG, {
            sourceId: "exitBtn"
        });
        this.props.actions.setNewDialog(config);
    }

    setBtnClass(){
        let disabled = false;
        if(appHelper.isDefined(this.props.disabled)){
            disabled = this.props.disabled;
        }

       return disabled ? "disabled" : "";
    }

    setIconClass(){
        return "icons8-cirlced-close";
    }
    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.exit();
        }
    }

    getLabel(){


        switch (this.props.contentData.experience.exit_style) {
            case navigationConstants.EXIT_STYLE_SAVE_AND_EXIT:
                return this.state.save_and_exit_label;
            case navigationConstants.EXIT_STYLE_EXIT:
                return this.state.exit_label;
            case navigationConstants.EXIT_STYLE_CLOSE:
                return this.state.close_label;
            default:
                return this.state.exit_label;
        }

    }

    render() {
        return (

                (appHelper.isDefined(this.props.contentData.experience.show_icons) && this.props.contentData.experience.show_icons) || !appHelper.isDefined(this.props.contentData.experience.show_icons) || this.state.env.isDevice
                    ?
                    <div className={`header-btn exit-btn ${this.setBtnClass()}`} onClick={this.exit} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="exit" title="Exit" id="exitBtn" ref={this.state.label} aria-disabled={this.props.disabled}>
                        <div className={`icon ${this.setIconClass()} `}/>
                        <div className="btn-label">{this.getLabel()}</div>
                    </div>
                    :
                    <div className={`header-btn`} onClick={this.exit} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="exit" title="Exit" id="exitBtn" ref={this.state.label} aria-disabled={this.props.disabled}>
                        <div className="nav-label">{this.getLabel()}</div>
                    </div>


        );
    }
}

ExitButton.propTypes = {
    disabled: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired

};

ExitButton.contextTypes = {

    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExitButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/ExitButton.js
 **/